import { Checkbox, CheckboxProps } from 'antd';
import {
  PrivacyPolicyLink,
  ServiceAgreementLink,
  // SoftWareLicenseLink,
} from 'components/AgreementsDocuments';
import { isQuickChat } from 'productLine';
import TransComponent from '../components/TransComponent';
import { T, useTranslate } from '@tolgee/react';

export interface AgreementsCheckboxProps extends CheckboxProps {}

const AgreementsCheckbox = (props: AgreementsCheckboxProps) => {
  const { t } = useTranslate();
  return (
    <Checkbox {...props}>
      {isQuickChat ? (
        <T
          keyName="quickchat_registry_agree_accept"
          params={{
            x: <TransComponent content={<ServiceAgreementLink />} />,
            y: <TransComponent content={<PrivacyPolicyLink />} />,
          }}
        />
      ) : (
        <>
          {t('ViewStartups.registry.info.form.agreement.label')}
          <ServiceAgreementLink />
          {t('ViewStartups.、')}
          <PrivacyPolicyLink />
          {/* 下线软件许可协议 @杜嘉鸿 */}
          {/* {t('ViewStartups.和')}
            <SoftWareLicenseLink /> */}
        </>
      )}
    </Checkbox>
  );
};
export default AgreementsCheckbox;
